import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import SectionHeading from '@/components/feature/SectionHeading';
import MovieCard from '@/components/feature/MovieCard';
import NewsCard from '@/components/feature/NewsCard';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryQuickLinks from '@/pages/home/components/CategoryQuickLinks';
import { movies } from '@/mocks/movies';
import { news } from '@/mocks/news';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Home() {
  usePageMeta({
    title: '河马AV - 专业影视内容平台与动态资讯',
    description:
      '河马AV聚焦最新影视资源和行业动态，提供丰富的影视内容介绍和资讯服务，满足用户多元影视信息需求。',
    keywords: '河马AV,影视内容,影视资讯,电影推荐,电视剧更新,影视平台',
  });

  const latest = [...movies].sort((a, b) => b.year - a.year).slice(0, 10);
  const hotNews = news.slice(0, 6);

  return (
    <Layout>
      <HeroCarousel />

      {/* 分类快捷入口 */}
      <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <SectionHeading title="影视分类" subtitle="按内容类型快速进入对应频道" />
        <CategoryQuickLinks />
      </section>

      {/* 最新影视推荐 */}
      <section className="bg-background-50">
        <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
          <SectionHeading
            title="最新影视推荐"
            subtitle="近期上线的影视作品，按年份择优推荐"
            moreTo="/category/movie"
            moreLabel="更多影视"
          />
          <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-5">
            {latest.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        </div>
      </section>

      {/* 热门资讯推荐 */}
      <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          title="热门资讯"
          subtitle="近期影视行业动态与作品观察"
          moreTo="/news"
          moreLabel="全部资讯"
        />
        <div className="scrollbar-hide -mx-4 flex gap-4 overflow-x-auto px-4 pb-2 md:mx-0 md:px-0">
          {hotNews.map((article) => (
            <NewsCard key={article.id} article={article} variant="card" />
          ))}
        </div>
      </section>

      {/* 网站简介 */}
      <section className="bg-primary-950">
        <div className="mx-auto flex max-w-7xl flex-col gap-8 px-4 py-12 md:flex-row md:items-center md:justify-between md:px-6 md:py-16">
          <div className="max-w-2xl">
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
              关于河马AV
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-primary-200 md:text-base">
              河马AV 定位为集影视资源介绍、行业动态资讯、推荐影视内容于一体的影视门户。
              我们为影视爱好者、行业从业者与普通观众提供最新作品信息、影评推荐与行业新闻，
              让每一次浏览都能发现下一部想看的好作品。
            </p>
          </div>
          <Link
            to="/about"
            className="flex w-fit shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            了解更多
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </section>
    </Layout>
  );
}